//component/SmoothScrolling.tsx
import "./SmoothScrolling.css";

function SmoothScrolling({ children }) {

  return (
    <div>
      {children}
    </div>
  );
}

export default SmoothScrolling;